function LoadMoreButton({ onClick, loading }) {
  return (
    <div className="load-more-row">
      <button
        type="button"
        className="load-more-btn"
        onClick={onClick}
        disabled={loading}
      >
        {loading ? "Loading..." : "Load More"}
      </button>
    </div>
  );
}

export default LoadMoreButton;
